module.exports = __webpack_public_path__ + "media/images/sp/top/soudan_comment-03-23922920bc327ec8d3a5e3f0e964fc22.svg";